<template>
  <div>
    <common-dialog
      ref="dialog"
      :width="isMB?'86%':'600px'"
      :title="text"
      :data="data"
      :form-rules="rules"
      :save-func="()=>{}"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-form-item label="流程名称" prop="ProcessId">
          <el-select v-model="data.ProcessId" @change="onChange" placeholder="请选择流程名称">
            <template v-for="(i,key) in Processes">
              <el-option :key="key" :label="i.ProcessName" :value="i.ProcessId"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <template v-if="data.ProcessId">
          <div v-loading="data.FormItems==0" style="min-height: 50px;">
            <template v-for="(i,key) in data.FormItems">
              <template v-if="i.FuncType > 0">
                <template v-if="i.ComponentType==0&&i.ItemType==2">
                  <div style="margin-left: 18px;" :key="key">
                    <span :style="i.Options">{{i.Explain}}</span>
                  </div>
                </template>
                <template v-else-if="i.ComponentType==1&&(i.ItemType==6||i.ItemType==7)"></template>
                <el-form-item
                  v-else
                  :label="i.ItemName"
                  :key="key"
                  :class="{'is-required':i.IsRequired}"
                >
                  <autoitem
                    :options="LeaveTypes"
                    :component-type="i.ComponentType"
                    :item-type="i.ItemType"
                    v-model="i.FormItemValue"
                    @change="onItemChange($event,i)"
                    :upload-data="{FormItemId:i.FormItemId}"
                  />
                </el-form-item>
              </template>
            </template>
          </div>
        </template>
      </template>
      <template slot="footer" slot-scope="{isLoading}">
        <el-button type="primary" :loading="isLoading" @click="save">提 交</el-button>
        <el-button @click="close">取 消</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import autoitem from "@/components/wf/common/index";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    autoitem,
  },
  data() {
    return {
      text: "请假申请",
      data: {
        ProcessId: null,
        FormItems: [],
      },
      Processes: [],
      LeaveTypes: [],
      isMB: this.$store.state.isMB,
      api: require("@/api/wf/instance").default,
      leave_type_api: require("@/api/ent/leaveType").default,
      rules: {
        ProcessId: [{ required: true, message: "选择流程" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      this.leave_type_api.list({}).then((res) => {
        this.LeaveTypes = res.Data;
      });
    },
    onChange(e) {
      this.data.FormItems = [];
      this.api.getInitInstance(this.data.ProcessId).then((res) => {
        this.data.FormItems = res.Data.FormItems.map((x) => {
          return { ...x, FormItemValue: "", Scale: 0 };
        });
        console.log("init", JSON.parse(JSON.stringify(this.data.FormItems)));
      });
    },
    onItemChange(data, row) {
      // console.log("item-change", JSON.parse(JSON.stringify(row)));
      if (row.ComponentType == 1 && row.ItemType == 0) {
        console.log("data", JSON.parse(JSON.stringify(data)));
        row.Scale = data.Scale;
      }
      if (row.ComponentType == 1 && (row.ItemType == 1 || row.ItemType == 2)) {
        // console.log("data", JSON.parse(JSON.stringify(data)));
        this.$nextTick(() => {
          var items = this.data.FormItems;
          var start = items.find((x) => x.ItemName == "开始时间");
          var end = items.find((x) => x.ItemName == "结束时间");
          var start_value = start.FormItemValue.split(" ");
          var end_value = end.FormItemValue.split(" ");
          // console.log("date", start_value, end_value);

          var diff_day = 0;
          if (start_value[0] && end_value[0]) {
            var range = this.data.FormItems.find(
              (x) => x.ItemName == "请假时长"
            );
            var start_time = new Date(start_value[0]).getTime() / 1000;
            var end_time = new Date(end_value[0]).getTime() / 1000;
            diff_day = parseInt((end_time - start_time) / 60 / 60 / 24); //相差天数
            if (diff_day < 0) {
              this.$message({
                customClass: "my-msg",
                type: "warning",
                message: "开始时间必须小于结束时间",
              });
              range.FormItemValue = 0;
              return;
            }
            var svalue = start_value[1];
            var evalue = end_value[1];

            if (svalue && evalue) {
              if (svalue == "上午" && evalue == "上午") {
                if (diff_day == 0) range.FormItemValue = 0.5;
                else range.FormItemValue = diff_day + 0.5;
              }
              if (svalue == "下午" && (evalue == "下午" || evalue == "晚上")) {
                if (diff_day == 0) range.FormItemValue = 0.5;
                else range.FormItemValue = diff_day + 0.5;
              }
              if (svalue == "上午" && evalue == "下午") {
                if (diff_day == 0) range.FormItemValue = 1;
                else range.FormItemValue = diff_day + 1;
              }
              if (svalue == "上午" && evalue == "晚上") {
                if (diff_day == 0) range.FormItemValue = 1;
                else range.FormItemValue = diff_day + 1;
              }
              if (svalue == "晚上" && evalue == "晚上") {
                if (diff_day == 0) range.FormItemValue = 0.5;
                else range.FormItemValue = diff_day + 0.5;
              }
              if (svalue == "晚上" && evalue == "下午") {
                if (diff_day == 0) {
                  this.$message({
                    customClass: "my-msg",
                    type: "warning",
                    message: "开始时间必须小于结束时间",
                  });
                  range.FormItemValue = 0;
                  return;
                } else range.FormItemValue = diff_day + 0.5;
              }
              if ((svalue == "下午" || svalue == "晚上") && evalue == "上午") {
                if (diff_day == 0) {
                  this.$message({
                    customClass: "my-msg",
                    type: "warning",
                    message: "开始时间必须小于结束时间",
                  });
                  range.FormItemValue = 0;
                  return;
                } else range.FormItemValue = diff_day;
              }
              // console.log("计算", range.FormItemValue, diff_day);
            }
          }
        });
      }
    },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        var data = { ...JSON.parse(JSON.stringify(this.data)) };

        var can_save = true;
        var err_msg = "";
        data.FormItems.forEach((x) => {
          if (x.IsRequired) {
            if (!x.FormItemValue) {
              can_save = false;
              err_msg += "<span>" + x.ItemName + "不能为空；</span><br />";
            }
            if (x.ItemName == "开始时间" || x.ItemName == "结束时间") {
              var value = x.FormItemValue.split(" ");
              if (value[1] == "") {
                can_save = false;
                err_msg += "<span>" + x.ItemName + "不能为空；</span><br />";
              } else {
                var item = data.FormItems.find(
                  (i) => i.ItemName == x.ItemName + "部分"
                );
                item.FormItemValue = value[1];
                x.FormItemValue = value[0];
              }
            }
          }
        });
        if (!can_save) {
          this.$message({
            customClass: "my-msg",
            type: "warning",
            dangerouslyUseHTMLString: true,
            message: err_msg,
          });
          return;
        }
        // console.log("api.save", JSON.parse(JSON.stringify(data)));
        // return;
        this.$refs.dialog.isLoading = true;
        this.api.submit(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message({
              customClass: "my-msg",
              type: "success",
              message: res.Msg,
            });
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message({
              customClass: "my-msg",
              type: "error",
              message: res.Msg,
            });
          }
        });
      });
    },
    onClosed() {},
  },
};
</script>